import { useMutation } from '@tanstack/react-query';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { apiClientOld } from '@/_config/lib/axios/api-client-old';

const postResetBalance = async () =>
  apiClientOld
    .post('/entregadores/reset-balance-last-week')
    .then(response =>
      handleResponseSuccess(response, 'Saldo resetado com sucesso!')(),
    )
    .catch(handleResponseThrowError('Não foi possível resetar o saldo.'));

export const useResetBalance = () => {
  return useMutation({
    mutationFn: () => postResetBalance(),
  });
};
